export class DealerApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDealers() {
    return this.#http.get('/Dealer');
  }

  async createDealer(body) {
    return this.#http.post('/Dealer', body);
  }

  async editDealer({ id, ...body }) {
    return this.#http.put(`/Dealer/${id}`, body);
  }

  async deleteDealer({ id }) {
    return this.#http.delete(`/Dealer/${id}`);
  }
}
